import {
  Box,
  Container,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useMemo, useState } from "react";
import TableActionButtons from "app/components/common/TableActionButtons";
import ExportButtonGroup from "app/components/common/ExportButtonGroup";
import InstituteListFilter from "app/components/Dialogs/InstituteList/InstituteListFilter";
import dayjs from "dayjs";
import ExportDialog from "app/components/common/exportDialog";
import InfiniteScrollTable from "app/components/Tables/InfiniteScrollTable";
import AccountStatusDialog from "app/components/Dialogs/School/AccountStatusDialog";
import ChangeDuesDateDialog from "app/components/Dialogs/InstituteList/ChangeDuesDateDialog";
import ChangetestingSchoolStatus from "app/components/Dialogs/School/ChangetestingSchoolStatus";
import { Helmet } from "react-helmet";
import RazorPayConfigDialog from "./components/RazorPayConfigDialog";
import { getRazorPayConfig } from "app/services/school/paymetGateway/razorpay";

const RazorPay = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [state, setState] = useState({
    filterDialog: false,
    callGetSchool: false,
    dataList: [],
    filterData: false,
    fetch: false,
    changeStatusDialog: false,
    changeDueDateDialog: false,
    openChangeAccountStatus: false,
    selectedItemSchoolDocId: "",
    currentAccountStatus: "",
    currentDueDate: new Date(),
    newDueDate: new Date(),
    statusData: {},
    tableData: [],
    page: 1,
    pages: 1,
    currentPage: 1,
    openChangeTestingSchoolStatus: false,
    currentTestingSchool: false,
    openRazorPayConfigDialog: false,
    selectedRazorPayKey: "",
    selectedRazorPaySecret: "",
    selectedActive: true,
  });
  const [enabled, setEnabled] = useState(false);

  const handleFilter = (payload) => {
    setState((prev) => ({ ...prev, filterData: payload, fetch: !prev.fetch }));
    setEnabled(true);
  };

  const [openCheckBox, setOpenCheckBox] = useState(false);

  let header = [
    "License Number",
    "School Name",
    "Director Name",
    "Due Date",
    "State",
    "District",
    "Account Status",
  ];
  let exportArray = state?.tableData?.map((item) => {
    return {
      "License Number": item?.ekalRefNumber,
      "School Name": item?.schoolName,
      "Director Name": item?.schoolAdmin?.personName,
      "Due Date": item?.upcomingDueDate
        ? `${dayjs(new Date(item?.upcomingDueDate)).format("DD-MM-YYYY")}`
        : "--",
      State: item?.schoolAddress?.state,
      District: item?.schoolAddress?.dist,
      "Account Status": item?.accountStatus,
    };
  });
  // showing table column
  const columns = useMemo(() => {
    return [
      {
        header: "Sr.No",
        Cell: ({ cell }) => (
          <Typography>{parseInt(cell.row.id) + 1}</Typography>
        ),
        maxSize: 20,
      },
      {
        header: "License No.",
        accessorKey: "schoolDocId",
        Cell: ({ cell, row }) => {
          return (
            <>
              {row?.original?.schoolDocId ? (
                <Typography>
                  {row?.original?.schoolDocId?.ekalRefNumber}
                </Typography>
              ) : (
                "---"
              )}
            </>
          );
        },
        maxSize: 40,
      },
      {
        header: "School Name",
        accessorKey: "schoolName",
        Cell: ({ cell, row }) => {
          return (
            <>
              {row?.original?.schoolDocId ? (
                <Typography>
                  {row?.original?.schoolDocId?.schoolName}
                </Typography>
              ) : (
                "---"
              )}
            </>
          );
        },
        maxSize: 30,
      },
      {
        header: "District",
        accessorKey: "schoolDocId.schoolAddress.dist",
        Cell: ({ row }) => {
          return (
            <>
              {row?.original?.schoolDocId?.schoolAddress ? (
                <Typography>
                  {row?.original?.schoolDocId?.schoolAddress?.dist}
                </Typography>
              ) : (
                "---"
              )}
            </>
          );
        },
        maxSize: 30,
      },

      {
        header: "Account Status",
        accessorKey: "schoolDocId",
        Cell: ({ cell, row }) => {
          return (
            <Stack direction="row" gap={0.5}>
              <Typography>
                {row?.original?.schoolDocId?.accountStatus}
              </Typography>
            </Stack>
          );
        },
        maxSize: 20,
      },
      {
        header: "RazorPay Key",
        accessorKey: "razorPay_key_id",
        // Cell: ({ cell, row }) => {
        //   return (
        //     <Stack direction="row" gap={0.5}>
        //       <Typography>
        //         {row?.original?.razorPayConfig?.key}
        //       </Typography>
        //     </Stack>
        //   );
        // },
        maxSize: 20,
      },

      {
        header: "Actions",
        Cell: ({
          cell: {
            row: { original },
          },
        }) => {
          return (
            <TableActionButtons
              showEdit
              handleEdit={() =>
                setState((prev) => ({
                  ...prev,
                  openRazorPayConfigDialog: true,
                  selectedItemSchoolDocId: original?.schoolDocId._id,
                  selectedRazorPayKey: original?.razorPay_key_id || "",
                  selectedRazorPaySecret: original?.razorPay_key_secret || "",
                  selectedActive: original?.active ?? true,
                }))
              }
            />
          );
        },
        maxSize: 20,
      },
    ];
  }, []);

  const handleCloseChangeDueDateDialog = () => {
    setState((prev) => ({
      ...prev,
      changeDueDateDialog: false,
      currentDueDate: new Date(),
      newDueDate: new Date(),
    }));
  };

  return (
    <>
      <Helmet>
        <title>Institute | Institute List</title>
      </Helmet>
      {/* filter Dialog */}
      <RazorPayConfigDialog
        open={state.openRazorPayConfigDialog}
        onClose={() =>
          setState((prev) => ({ ...prev, openRazorPayConfigDialog: false }))
        }
        schoolDocId={state.selectedItemSchoolDocId}
        razorPayKey={state.selectedRazorPayKey}
        razorPaySecret={state.selectedRazorPaySecret}
        active={state.selectedActive}
        refetch={() => {
          setEnabled((prev) => !prev); // for calling the api again
        }}
      />
      <AccountStatusDialog
        open={state.openChangeAccountStatus}
        onClose={() =>
          setState((prev) => ({ ...prev, openChangeAccountStatus: false }))
        }
        refetch={() => {
          setEnabled(true); //for calling the api again
        }}
        schoolDocId={state.selectedItemSchoolDocId}
        status={state.currentAccountStatus}
      />
      <ChangetestingSchoolStatus
        open={state.openChangeTestingSchoolStatus}
        onClose={() =>
          setState((prev) => ({
            ...prev,
            openChangeTestingSchoolStatus: false,
          }))
        }
        refetch={() => {
          setEnabled(true);
        }}
        schoolDocId={state.selectedItemSchoolDocId}
        status={state.currentTestingSchool}
      />
      <ExportDialog
        open={openCheckBox}
        handleClose={() => setOpenCheckBox(false)}
        header={header}
        exportArray={exportArray}
        fileName="Institute List"
      />

      <ChangeDuesDateDialog
        state={state}
        setState={setState}
        handleCloseChangeDueDateDialog={handleCloseChangeDueDateDialog}
        handleRefetch={() => {
          setEnabled(true); //for calling the api again
        }}
      />

      <Container maxWidth="xl" disableGutters={isMobile ? true : false}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box>
            <InstituteListFilter mutate={handleFilter} />
          </Box>
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <ExportButtonGroup
              showExcel
              handleClickExcel={() => setOpenCheckBox(true)}
            />
          </Box>
        </Stack>
        <Box sx={{ mt: 2 }}>
          <InfiniteScrollTable
            columns={columns}
            maxHeight="60vh"
            apiUrl={getRazorPayConfig}
            apiParams={state.filterData}
            setState={setState}
            enabled={enabled}
            setEnabled={setEnabled}
            filterRefresh={false}
          />
        </Box>
      </Container>
    </>
  );
};

export default RazorPay;
